import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import { ResetPassword } from './components/ResetPassword'
import { VerifyOTP } from './components/VerifyOTP'
import { LoginWithSeller } from './components/LoginWithSeller'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='loginwithseller' element={<LoginWithSeller />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password/:token' element={<ResetPassword />} />
      <Route path='verifyotp' element={<VerifyOTP />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
